import { Component, OnInit } from '@angular/core';
import { PoliticaTermoBi } from 'app/resources/bi/PoliticaTermo.bi';
import { RequestPoliticaTermo } from 'app/resources/classes/RequestPoliticaTermo';
import { MainService } from 'app/resources/services';
import { HttpService } from 'app/resources/services/http.service';
import { PoliticaTermoService } from 'app/resources/services/politica-termo.service';
import { first, finalize } from 'rxjs/operators';

declare var $: any;
@Component({
  selector: 'app-modal-politica-termo',
  templateUrl: './modal-politica-termo.component.html',
  styleUrls: ['./modal-politica-termo.component.css']
})
export class ModalPoliticaTermoComponent implements OnInit {

  public policiesAccepted: boolean;
  public termAccepted: boolean;
  private requestAcceptTermPolices: RequestPoliticaTermo;
  public loading: boolean;

  constructor(
    private httpService: HttpService,
    private mainService: MainService,
    private politicaTermoService: PoliticaTermoService
  ) { }

  ngOnInit() {
    this.abrirModal();
  }

  public abrirModal(): void {
    $('#myModalPolicesTerms').modal('show');
    $('#myModalPolicesTerms').on('hidden.bs.modal');

  }

  public readPoliciesAndTerms() {
    window.open('#/politicas-e-termos', '_parent');
    $('#myModalPolicesTerms').modal('hide');
  }

  private closeDialog() {
    $('#myModalPolicesTerms').modal('hide');
  }

  public checkAcceptTerms(): void {
    this.loading = true;
    new PoliticaTermoBi.Rest(this.httpService).acceptanceCheck(this.mainService.sessionService.getUserUuid(), this.mainService.sessionService.getUserId())
      .pipe(
        first(),
        finalize(() => {
          this.loading = false;
          if (this.politicaTermoService.isAcceptedPoliciesAndTerms()) {
            this.closeDialog();
          }
        }))
      .subscribe(
        success => {
          this.politicaTermoService.setResponseTermoUso(PoliticaTermoBi.Parser.fill(success.json()));
        }, error => {
          bootbox.alert('Erro ao consultar o aceite dos termos.');
        }
      );
  }

  public acceptTerms(): void {
    this.loading = true;
    this.requestAcceptTermPolices = new RequestPoliticaTermo();
    this.requestAcceptTermPolices.setTermoAceito(this.termAccepted);
    this.requestAcceptTermPolices.setPrivacidadeAceita(this.policiesAccepted);
    this.requestAcceptTermPolices.setIdUsuario(this.mainService.sessionService.getUserId());
    this.requestAcceptTermPolices.setUuid(this.mainService.sessionService.getUserUuid());
    if (this.termAccepted && this.policiesAccepted) {
      new PoliticaTermoBi.Rest(this.httpService).acceptTerm(this.requestAcceptTermPolices)
        .pipe(
          first(),
          finalize(() => {
            this.loading = false;
          }))
        .subscribe(
          success => {
            bootbox.alert('Políticas de Privacidade e Termos de uso aceitos com sucesso!');
            this.checkAcceptTerms();
          }, error => {
            bootbox.alert('Não foi possível aceitar as Políticas de Privacidade e os Termos de Uso');
          }
        );
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/politica-termo/modal-politica-termo/modal-politica-termo.component.ts